module.exports = __webpack_public_path__ + "img/Loyalty-ability-05.c002ee23.png";